var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDecagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 8.00068L14.2065 6.14734L14.4332 3.69401L12.0265 3.14734L10.7665 1.02734L8.49984 2.00068L6.23317 1.02734L4.97317 3.14734L2.5665 3.68734L2.79317 6.14068L1.1665 8.00068L2.79317 9.85401L2.5665 12.314L4.97317 12.8607L6.23317 14.9807L8.49984 14.0007L10.7665 14.974L12.0265 12.854L14.4332 12.3073L14.2065 9.85401L15.8332 8.00068ZM7.1665 11.334L4.49984 8.66734L5.43984 7.72734L7.1665 9.44734L11.5598 5.05401L12.4998 6.00068L7.1665 11.334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDecagram);
export default __webpack_public_path__ + "static/media/check-decagram.131f27ad0cc49b74d767df4e1cf5e547.svg";
export { ForwardRef as ReactComponent };